var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-container",
    class: _vm.wrapperClasses
  }, [_c('image-block', {
    staticClass: "image-wrapper",
    attrs: {
      "icon": _vm.content.icon,
      "image": _vm.content.image
    }
  }), _c('div', {
    staticClass: "message-wrapper"
  }, [_c('h3', [_vm._v(_vm._s(_vm.content.title))]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.body)
    }
  })]), _vm.content.button ? _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.content.button) + " ")]) : _vm._e(), _vm.content.loading ? _c('loading-spinner') : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }